import React, { Component } from 'react';
import ModalOdontogram from './ModalOdontogram';
import { OdontogramContext } from '../../../../context';
import './odontogram.css';

export default class Odontogram extends Component {
  static contextType = OdontogramContext;

  state = {
    modalShow: false
  };

  handleDoubleClick = () => {
    if (this.props.readOnly) {
      return
    }
    this.setState({
      modalShow: true
    });
  };

  handleSubmit = () => {
    this.setState({
      modalShow: false
    });
  };

  render() {
    const { element, alt } = this.props;
    const statusImage = this.props.statusImage;
    const modalShow = this.state.modalShow;
    return (
      <>
        <td align='center' style={{padding: 0}}>
          <div
            className='container'
            onDoubleClick={ () => this.handleDoubleClick(this.props) }
            onClick={ () => this.context.handleHistoryClick(element) }
          >
            <img className='image' src={ statusImage ? statusImage : 'no' } alt={ alt } />
            <div className='overlay'></div>
          </div>
          <span>{element}</span>
          {modalShow ? (
            <ModalOdontogram element={ element } handleSubmit={ this.handleSubmit } show={ modalShow } onHide={ () => this.setState({ modalShow: false }) } />
          ) : (
            ''
          )}
        </td>
      </>
    );
  }
}
